"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDictateState;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

// TODO: [P3] We should update this code to use core/src/selectors/dictateState.js
function useDictateState() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var dictateState = _ref.dictateState;
    return dictateState;
  })];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VEaWN0YXRlU3RhdGUudHMiXSwibmFtZXMiOlsidXNlRGljdGF0ZVN0YXRlIiwiZGljdGF0ZVN0YXRlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUE7QUFDZSxTQUFTQSxlQUFULEdBQXFDO0FBQ2xELFNBQU8sQ0FBQyxzQ0FBWTtBQUFBLFFBQUdDLFlBQUgsUUFBR0EsWUFBSDtBQUFBLFdBQXNCQSxZQUF0QjtBQUFBLEdBQVosQ0FBRCxDQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZVNlbGVjdG9yIH0gZnJvbSAnLi9pbnRlcm5hbC9XZWJDaGF0UmVkdXhDb250ZXh0JztcblxuLy8gVE9ETzogW1AzXSBXZSBzaG91bGQgdXBkYXRlIHRoaXMgY29kZSB0byB1c2UgY29yZS9zcmMvc2VsZWN0b3JzL2RpY3RhdGVTdGF0ZS5qc1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlRGljdGF0ZVN0YXRlKCk6IFtudW1iZXJdIHtcbiAgcmV0dXJuIFt1c2VTZWxlY3RvcigoeyBkaWN0YXRlU3RhdGUgfSkgPT4gZGljdGF0ZVN0YXRlKV07XG59XG4iXX0=